import React from 'react'
import { useTranslation } from 'react-i18next'
import { AlertTriangle } from 'lucide-react'

type UnexpectedErrorFallbackProps = {
  onRetry: () => void
}

export function UnexpectedErrorFallback({ onRetry }: UnexpectedErrorFallbackProps) {
  const { t } = useTranslation()

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center p-8 text-center" dir="rtl">
      <div
        className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-destructive/12 ring-1 ring-destructive/25"
        aria-hidden
      >
        <AlertTriangle className="h-8 w-8 text-destructive" strokeWidth={2} />
      </div>
      <h3 className="mb-2 text-lg font-semibold text-foreground">{t('common.unexpectedError.title')}</h3>
      <p className="mb-4 text-muted-foreground">{t('common.unexpectedError.description')}</p>
      <button
        type="button"
        onClick={onRetry}
        className="rounded-lg bg-primary px-4 py-2 text-primary-foreground transition-colors hover:bg-primary-hover"
      >
        {t('common.unexpectedError.reload')}
      </button>
    </div>
  )
}
